import React from 'react';
import styled from 'styled-components';
import { strings } from '/imports/strings';
import { Orgs, orgName } from '/imports/api/orgs';
import { css } from '/imports/ui/css';
import { Icon } from '/imports/ui/Icon';
import { setOrgId } from '/imports/api/users';

const NoOrgSelectedPageStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  color: ${props => props.theme.main === 'dark' ? '#FFF' : css.grey1};
  .wrapper {
    margin: auto;
  }
  .icon {
    svg {
      width: 25rem;
      * {
        stroke: ${props => props.theme.main === 'dark' ? css.primaryColor : css.secondaryColor};
      }
    }
  }
  p {
    text-align: center;
    font-size: 1.1rem;
    a {
      color: ${css.secondaryColor};
      &:hover {
        color: ${css.primaryColor};
      }
    }
  }
  .orgs {
    max-height: 10rem;
    overflow: auto;
    .org {
      cursor: pointer;
      color: ${css.secondaryColor};
      &:hover {
        color: ${css.primaryColor};
      }
    }
  }
`;

/** Prompt shown when no org is selected; lists orgs and lets the user pick one. */
export const NoOrgSelectedPage = () => {
  /**
   * Set the active org and reload.
   * @param orgId - org to select
   */
  const setOrg = async (orgId: string) => {
    await setOrgId.call(orgId);
    window.location.reload();
  };
  return (
    <NoOrgSelectedPageStyled className="page">
      <div className="wrapper">
        <Icon icon="group" />
        <h2>{strings.PleaseSelectAnOrganization()}</h2>
        <div className="orgs">
          {
            Orgs.find().fetch().map((org) => {
              return (
                <div className="org" key={org._id} onClick={() => setOrg(org._id)}>{orgName(org)}</div>
              );
            })
          }
        </div>
      </div>
    </NoOrgSelectedPageStyled>
  );
};